
import { defineComponent } from "vue";

import Board from "@/components/Board/GameBoard.vue";
import PlayerArea from "@/components/Player/PlayerArea.vue";
import PlayerPicture from "@/components/Elements/PlayerPicture.vue";

import PublicGameState from "@/models/PublicGameState";

export default defineComponent({
  name: "StartedGameView",
  inject: ["game"],
  data: () => ({
    assetsLoaded: false,
  }),
  computed: {
    activePlayerId(): number | null {
      return this.game.activePlayerId;
    },
    gameState(): PublicGameState | null {
      return this.game.publicState;
    },
    playerIds(): number[] {
      const ids = this.gameState?.players.map(({ id }) => id) ?? [];
      if (this.activePlayerId && !this.game.isDebug) {
        const activePlayerIndex = ids.findIndex(
          (id) => this.activePlayerId === id
        );
        return [
          ...ids.slice(activePlayerIndex),
          ...ids.slice(0, activePlayerIndex),
        ];
      } else {
        return ids;
      }
    },
    winner(): { id: number; name: string } | null {
      return this.gameState?.winner
        ? this.game.getPlayer(this.gameState?.winner) ?? null
        : null;
    },
  },
  async beforeMount() {
    const preloadImage = (src: string) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = resolve;
        image.onerror = reject;
        image.src = src;
      });
    const colors = ["yellow", "blue", "red", "white"];
    const resources = ["brick", "grain", "lumber", "ore", "wool"];

    await Promise.all(
      [
        ...colors.map((color) => require(`@/assets/road-${color}-front.webp`)),
        ...colors.map((color) => require(`@/assets/road-${color}-side.webp`)),
        ...colors.map((color) => require(`@/assets/road-${color}-side-2.webp`)),
        ...colors.map((color) => require(`@/assets/settlement-${color}.webp`)),
        ...colors.map((color) => require(`@/assets/city-${color}.webp`)),
        ...resources.map((resource) =>
          require(`@/assets/tile-${resource}.webp`)
        ),
        ...resources.map((resource) => require(`@/assets/${resource}.webp`)),
        require("@/assets/tile-desert.webp"),
        require("@/assets/dock.webp"),
        require("@/assets/thief.webp"),
        require("@/assets/someone.webp"),
        require("@/assets/board-background.webp"),
        ...[1, 2, 3, 4, 5, 6].map((i) => require(`@/assets/dice-${i}.webp`)),
      ].map((url) => preloadImage(url))
    );
    this.assetsLoaded = true;
  },
  components: {
    Board,
    PlayerArea,
    PlayerPicture,
  },
});
